import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 获取在职状态
import { searchStaffFn } from 'api/org/per';
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String, Array],
      default: ''
    }
  },
  data: function data() {
    return {
      timer: null,
      supLoading: false,
      supOptions: [] // 可选项
    };
  },

  methods: {
    supRemoteMethod: function supRemoteMethod(query) {
      var _this = this;
      if (query !== '') {
        this.supLoading = true;
        // ajax请求
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          searchStaffFn({
            search_name: query,
            page_size: 20
          }).then(function (res) {
            _this.supLoading = false;
            if (res && res.code === 1) {
              _this.supOptions = res.data.map(function (v) {
                return {
                  staff_name: v.staff_name,
                  staff_id: v.staff_id
                };
              });
            }
          });
        }, 300);
      } else {
        this.supOptions = [];
      }
    },
    handlerChange: function handlerChange(v) {
      this.$emit('input', v);
    }
  }
};